import BadgeDetailLayout from '@/layouts/BadgeDetail';
import BadgeDetailMembers from '@/screens/BadgeDetail/BadgeDetailMembers';

export default function PrivateTabsTeamBadgeBadgeIdIndexRoute() {
  return (
    <BadgeDetailLayout>
      <BadgeDetailMembers />
    </BadgeDetailLayout>
  );
}
